// Copyright (c) 2016 Deere & Company

import ProductDetails from './components/product-details';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.productDetails,
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    isSapUp: state.app.sapStatus.isSapUp,
    measurementReadings: state.latestPerUnitMeasurements,
    updateAmountOfUseMeasurement: state.updateUnitMeasurements
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ProductDetails);



// WEBPACK FOOTER //
// ./src/product/details/state-connector.js